
// @ts-ignore
import scssBreakpoints from './export.module.scss';
import { Breakpoint } from './models';

interface SCSSBreakpoints {
    'xxs-min': number
    'xxs-max': number
    'xs-min': number
    'xs-max': number
    'lg-min': number
    'lg-max': number
    'md-min': number
    'md-max': number
    'sm-min': number
    'sm-max': number
    'xl-min': number
    'xl-max': number
    'xxl-min': number
    'xxl-max': number
    'xxxl-min': number
    'xxxl-max': number
}
for (const key of Object?.keys((scssBreakpoints ?? {}) as Record<string, string>)) {
     // @ts-ignore
    scssBreakpoints[key] = Number(scssBreakpoints[key])
}
 // @ts-ignore
export const breakpoints: SCSSBreakpoints = { ...scssBreakpoints }

export const breakpointsMax: Record<Breakpoint, number> = (
    Object?.fromEntries(
        Object?.entries(breakpoints).filter(([k]) => k.endsWith('-max')).map((arr) => {arr[0] = arr[0].replace('-max', ''); return arr})
    ) as Record<Breakpoint, number>
)
export const breakpointsMin: Record<Breakpoint, number> = (
    Object?.fromEntries(
        Object?.entries(breakpoints).filter(([k]) => k.endsWith('-min')).map((arr) => {arr[0] = arr[0].replace('-min', ''); return arr})
    ) as Record<Breakpoint, number>
)
